var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c("div", { staticClass: "popup-container" }, [
    _c(
      "div",
      { staticClass: "popup-content" },
      [
        _vm.showSuccessContent
          ? [
              _c("p", { staticClass: "popup-message" }, [
                _vm._v(_vm._s(_vm.$t("providers.closePopup")))
              ])
            ]
          : _c("div", { staticClass: "popup-message" }, [
              _c("p", { staticClass: "popup-error-title" }, [
                _vm._v("Provider connection error")
              ]),
              _c("p", {}, [_vm._v(_vm._s(_vm.errorCode))])
            ]),
        _c(
          "button",
          {
            staticClass: "popup-button",
            attrs: { type: "button" },
            on: { click: _vm.handleClose }
          },
          [_vm._v(" Close ")]
        )
      ],
      2
    )
  ])
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }